module.exports = __webpack_public_path__ + "static/media/corporateHub-banner.617ca163.png";